import styled from 'styled-components';

import { wellzTheme } from '@wellz-theme/mui';

export const CalendarWrapper = styled.div`
  background: ${({ theme }) => theme.yoga.colors.white};
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  padding: ${({ theme }) => theme.yoga.spacing.large}px;

  thead {
    border-bottom: ${({ theme }) => theme.yoga.borders.small}px solid
      ${({ theme }) => theme.yoga.colors.elements.lineAndBorders};
  }

  th .fc-day-today a {
    color: ${({ theme }) =>
      theme.yoga.colors.elements.selectionAndIcons} !important;
  }

  .fc-header-toolbar {
    margin-bottom: ${({ theme }) => theme.yoga.spacing.small}px !important;
  }

  .fc-timegrid-slot-minor {
    border-top-style: double;
  }

  .fc-timegrid-now-indicator-line {
    border-width: ${({ theme }) => theme.yoga.borders.small}px;
  }

  .fc-theme-standard td {
    border-bottom: ${({ theme }) => theme.yoga.borders.small}px solid
      ${({ theme }) => theme.yoga.colors.elements.lineAndBorders};
  }

  .fc-theme-standard th {
    border-bottom: none;
  }

  .fc-timegrid-col {
    background: ${({ theme }) => theme.yoga.colors.white} !important;
  }

  .fc-event:not(.fc-custom-background-event) {
    cursor: pointer;
  }

  .fc-timegrid-event-harness-inset {
    left: 0 !important;
  }

  .fc-list-day-cushion {
    background: transparent;
  }

  .fc-custom-event {
    margin: 0 4px;
  }

  .fc-list {
    border: 0 !important;
    /* border-color: 'transparent' !important; */
  }

  .fc-event-main {
    background-color: ${({ theme }) => theme.yoga.colors.primary};
    font-weight: ${({ theme }) => theme.yoga.fontWeights.regular};
    font-size: ${({ theme }) => theme.yoga.fontSizes.xsmall}px;
    line-height: ${({ theme }) => theme.yoga.lineHeights.xsmall}px;

    .fc-event-time {
      font-size: ${({ theme }) => theme.yoga.fontSizes.xxsmall}px;
      line-height: ${({ theme }) => theme.yoga.lineHeights.xxsmall}px;
    }

    *,
    *::before,
    *::after {
      color: ${({ theme }) => theme.yoga.colors.white};
    }
  }

  .fc-bg-event {
    left: 0;
    border: none;
    pointer-events: none;
    background-color: transparent;
    box-shadow: none !important;

    .fc-event-time {
      display: none;
    }

    .fc-event-main {
      background: none !important;
    }

    .fc-event-time {
      background: none !important;
    }

    .fc-v-event {
      background: none !important;
    }

    &.unavailable {
      background-color: #c8c8c8 !important;
    }

    &.allow-period {
      opacity: 0.75;
      z-index: 3 !important;
      background-color: ${({ theme }) =>
        theme.yoga.colors.feedback.success.light} !important;
    }

    &.block-period {
      opacity: 0.75;
      z-index: 3 !important;
      background-color: ${({ theme }) =>
        theme.yoga.colors.feedback.attention.light} !important;
    }
  }

  .fc-timegrid-event {
    border-color: ${({ theme }) => theme.yoga.colors.primary};
  }

  .fc-list-event-graphic {
    @media screen and (max-width: 1024px) {
      display: none;
    }
  }

  .fc-list-event-title {
    @media screen and (max-width: 1024px) {
      text-align: right;
    }
  }

  .fc-list-event-dot {
    border-color: ${({ theme }) => theme.yoga.colors.primary};
  }

  .fc-icon-left-single-arrow {
    box-sizing: border-box;
    position: relative;
    display: block;
    transform: scale(var(--ggs, 1));
    width: ${({ theme }) => theme.yoga.spacing.medium}px;
    height: ${({ theme }) => theme.yoga.spacing.medium}px;
    border: ${({ theme }) => theme.yoga.borders.medium}px solid transparent;

    &::after {
      content: '';
      display: block;
      box-sizing: border-box;
      position: absolute;
      width: ${({ theme }) => theme.yoga.spacing.xsmall}px;
      height: ${({ theme }) => theme.yoga.spacing.xsmall}px;
      border-bottom: ${({ theme }) => theme.yoga.borders.medium}px solid;
      border-left: ${({ theme }) => theme.yoga.borders.medium}px solid;
      transform: rotate(45deg);
      left: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
      top: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
      color: ${({ theme }) => theme.yoga.colors.white};
    }
  }

  .fc-icon-right-single-arrow {
    box-sizing: border-box;
    position: relative;
    display: block;
    transform: scale(var(--ggs, 1));
    width: ${({ theme }) => theme.yoga.spacing.medium}px;
    height: ${({ theme }) => theme.yoga.spacing.medium}px;
    border: ${({ theme }) => theme.yoga.borders.medium}px solid transparent;

    &::after {
      content: '';
      display: block;
      box-sizing: border-box;
      position: absolute;
      width: ${({ theme }) => theme.yoga.spacing.xsmall}px;
      height: ${({ theme }) => theme.yoga.spacing.xsmall}px;
      border-bottom: ${({ theme }) => theme.yoga.borders.medium}px solid;
      border-right: ${({ theme }) => theme.yoga.borders.medium}px solid;
      transform: rotate(-45deg);
      right: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
      top: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
      color: ${({ theme }) => theme.yoga.colors.white};
    }
  }

  .event-active {
    * {
      color: ${({ theme }) => theme.yoga.colors.text.primary};
    }

    .fc-event-main {
      background-color: ${({ theme }) => theme.yoga.colors.primaryExtraLight};
    }

    &:focus {
      &::before {
        content: none;
      }

      &::after {
        content: none;
      }
    }

    &.fc-timegrid-event {
      border-color: ${({ theme }) =>
        theme.yoga.colors.primaryExtraLight} !important;
    }
  }

  @media screen and (max-width: 1024px) {
    .fc-toolbar-chunk {
      .fc-button-primary {
        all: unset;
        cursor: pointer;
      }

      .fc-prev-button {
        width: ${wellzTheme.spacing(3)};
        height: ${wellzTheme.spacing(3)};

        .fc-icon-left-single-arrow::after {
          color: ${wellzTheme.palette.primary.main};
        }

        &:active {
          background-color: transparent;
          .fc-icon-left-single-arrow::after {
            color: ${wellzTheme.palette.primary.dark};
          }
        }

        &:disabled {
          cursor: not-allowed;

          .fc-icon-left-single-arrow::after {
            color: ${wellzTheme.palette.action.disabled};
          }
        }
      }

      .fc-next-button {
        width: ${wellzTheme.spacing(3)};
        height: ${wellzTheme.spacing(3)};

        .fc-icon-right-single-arrow::after {
          color: ${wellzTheme.palette.primary.main};
        }

        &:active {
          background-color: transparent;
          .fc-icon-right-single-arrow::after {
            color: ${wellzTheme.palette.primary.dark};
          }
        }

        &:disabled {
          cursor: not-allowed;
          .fc-icon-right-single-arrow::after {
            color: ${wellzTheme.palette.action.disabled};
          }
        }
      }

      .fc-today-button {
        border: 1px solid ${wellzTheme.palette.primary.main};
        border-radius: ${wellzTheme.spacing(3)};
        padding: ${wellzTheme.spacing(0.5)} ${wellzTheme.spacing(1.25)};
        color: ${wellzTheme.palette.primary.main};

        &:active {
          background-color: ${wellzTheme.palette.primary.main};
          color: ${wellzTheme.palette.common.white};
        }
      }
    }

    .fc-toolbar-title {
      font-family: ${wellzTheme.typography.body1.fontFamily};
      color: ${wellzTheme.typography.body1.color};
      font-size: ${wellzTheme.typography.body1.fontSize};
      font-weight: ${wellzTheme.typography.body1.fontWeight};
    }

    .fc-header-toolbar.fc-toolbar.fc-toolbar-ltr > div:nth-child(1) > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: ${wellzTheme.spacing(1.5)};
    }

    .tags {
      display: none;
    }
  }
`;

// AgendaTags does not have access to yoga

export const TagsContainer = styled.div`
  display: flex;
  margin-bottom: 16px;
`;

export const Tag = styled.div`
  display: flex;
  color: #6b6b78;
  font-size: 14px;
  margin-right: 16px;
  align-items: center;
`;

export const TagColor = styled.div<{ hasBorder: boolean; color: string }>`
  width: 14px;
  height: 14px;
  opacity: 0.75;
  margin-right: 8px;
  background-color: ${props => props.color};
  ${props => props.hasBorder && 'border: 1px solid;'}
`;
